// extracted by mini-css-extract-plugin
export var audioPlayer = "_tt-0";